export default __webpack_public_path__ + "static/media/P2-sm-open.8cdb9f81.svg";